var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3856 0C7.02112 0.00586637 0.222955 6.7258 0.00687693 15.0873C-0.047876 17.1973 0.221 19.2143 0.932788 21.0613C0.932788 21.0613 -1.43528 9.57979 7.32617 3.58044C9.57299 2.08745 12.7848 1.33949 15.6985 1.40206C23.0755 1.56046 29.5422 8.21684 29.593 15.5958C29.6448 23.2035 22.9923 29.591 15.3973 29.591C13.1378 29.591 10.6896 29.0483 8.9316 27.8741C6.3631 26.1582 6.32106 23.4147 7.15409 21.1434C9.48109 14.7999 13.2669 5.55937 15.3973 5.35893C16.3848 5.26605 19.1068 9.31287 23.1566 22.5738C23.1674 22.608 23.1722 22.6374 23.1752 22.6647C23.6044 23.2905 24.0131 23.9749 24.0131 23.9749C23.6562 23.5066 23.0813 23.0157 22.5181 22.5953C16.5119 18.2914 9.53486 16.9822 9.53486 16.9822L9.25621 17.6099C9.25621 17.6099 15.3983 18.7773 23.0363 24.1792C23.6543 24.6163 24.2644 24.5928 24.3964 23.9622C24.6956 22.5347 18.6297 4.11331 15.3915 4.11331C13.1701 4.11331 8.46229 14.6014 6.06587 21.1375C4.78407 24.6329 5.93388 28.0452 9.35105 29.5235C11.2361 30.3389 13.3157 30.7916 15.5 30.7906C24.0121 30.7906 30.8787 24.2301 30.8934 15.718C30.9081 7.14427 23.9583 -0.00586617 15.3866 0.000977938L15.3856 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c52c7c15904e30863646709412fb9a2.svg";
export { ForwardRef as ReactComponent };